import { ExamCourseProvider } from '@exam-center/admin-exam-course-details';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function AdminExamCourseLayout() {
  const { examCourseCode } = useParams('/admin/exam-courses/:examCourseCode');

  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_COURSE_MANAGEMENT.SETTINGS.VIEW}
    >
      <ExamCourseProvider examCourseCode={examCourseCode}>
        <Outlet />
      </ExamCourseProvider>
    </PermissionGuard>
  );
}
